import { CRITERION_OPTIONS, type CriterionId } from "@/types/content";

type Section3CriterionProps = {
  value: CriterionId | null;
  onChange: (v: CriterionId) => void;
};

export function Section3Criterion({ value, onChange }: Section3CriterionProps) {
  const selectedLabel = CRITERION_OPTIONS.find((o) => o.id === value)?.title;

  return (
    <section className="relative mx-4 my-5 overflow-hidden rounded-[28px] border border-forest-100 bg-gradient-to-br from-forest-50 to-paper px-[22px] py-8">
      <div
        className="pointer-events-none absolute -right-20 -top-16 h-60 w-60 rounded-full opacity-50"
        style={{
          background: "radial-gradient(circle, rgb(255 221 211), transparent 70%)",
        }}
        aria-hidden
      />
      <p className="kicker relative mb-3">第三段 · 一个小问题</p>
      <h2 className="relative mb-[18px] text-[22px] font-bold leading-snug tracking-tight text-ink-900">
        以下几个居住要求,
        <span className="bg-gradient-to-b from-transparent from-[62%] to-coral-100 to-[62%] px-1 text-coral-900">
          {" "}
          你最看重哪一点?
        </span>
        <span className="mt-2 block text-[13px] font-medium tracking-normal text-ink-500">
          点击下方选项告诉我们。
        </span>
      </h2>

      <ul className="relative flex flex-col gap-2">
        {CRITERION_OPTIONS.map((opt, idx) => {
          const selected = value === opt.id;
          return (
            <li key={opt.id}>
              <button
                type="button"
                onClick={() => onChange(opt.id)}
                className={`flex w-full items-center gap-3 rounded-[14px] px-4 py-3.5 text-left transition ${
                  selected
                    ? "border-2 border-coral-700 bg-coral-50 shadow-[0_6px_18px_rgba(236,75,54,0.16)]"
                    : "border border-ink-200 bg-paper shadow-card"
                }`}
              >
                <span
                  className={`flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full text-[11px] font-extrabold ${
                    selected
                      ? "bg-coral-700 text-white"
                      : "border border-ink-200 bg-surface-50 text-ink-600"
                  }`}
                >
                  {selected ? (
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden>
                      <path
                        d="M3 6.5l2.5 2.5L10 4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    String.fromCharCode(65 + idx)
                  )}
                </span>
                <span>
                  <span className="block text-[15px] font-bold tracking-tight text-ink-900">
                    {opt.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-ink-500">{opt.sub}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      {value && selectedLabel ? (
        <div className="fade-up relative mt-3.5 flex items-center gap-2.5 rounded-xl border border-coral-100 bg-coral-50 px-3.5 py-2.5 text-[12.5px] leading-snug text-ink-700">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-coral-700 text-white">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
              <path
                d="M2.5 6l2.5 2.5L9 4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="min-w-0 flex-1">
            已按<strong className="font-bold text-coral-900"> {selectedLabel} </strong>
            重新排序。
          </span>
        </div>
      ) : null}
    </section>
  );
}
